module.exports = __webpack_public_path__ + "img/1438777012.40b674c7.jpg";